import React from 'react';
import { useRouter } from '../../../../../@casino/useRouter';
import Dialog from '@material-ui/core/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { setPostBlockUser } from '../../store/thunk/setPostBlockUser';
import { setUpdatePassword } from '../../store/thunk/setUpdatePassword';
import { setGetLastOperationAction, setGetRezymeAction, setGetReplenishmentUserAction, setGetWithdrawalsUserAction, setGetHistoryBonusGetByIdAction, setGetJackpotHistoryListAction } from '../../store/action';
import { setGetJackpotList } from '../../store/thunk/setGetJackpotList';
import { setGetLastOperation } from '../../store/thunk/setGetLastOperation';
import { setPostJackpotIssue } from '../../store/thunk/setPostJackpotIssue';
import { Allow as AllowMap} from '../../../../settings/allow';

const Navigation = ({isShowNavigation, setIsShowNavigation, id, profile}) => {
    const dispatch = useDispatch();

    const view = useSelector(state => state.auth.admin);


    React.useEffect(() => {
        dispatch(setGetLastOperation({
            id,
            page: 1,
            rowsPerPage: 20
        }))
    }, [id])
    
    const router = useRouter();
    const [openModalBlock, setOpenModalBlock] = React.useState(false);
    const [openModalPassword, setOpenModalPassword] = React.useState(false);
    const [randomPassword, setRandomPassword] = React.useState('');
    const [jackpot, setJackpot] = React.useState(false);
    const [itemJackpot, setItemJackpot] = React.useState('');

    const jackpot_group = useSelector(state => state.usersMobile.jackpot);

    const navigation = [
        {label: 'Пользователь', url: `/gamer/view/${id}`},
        {label: 'Отчет по играм', url: `/gamer/view/${id}/report-games`, click: () => dispatch(setGetRezymeAction({
            data: [],
            countPage: 1
        }))},
        {label: 'Последние действия', url: `/gamer/view/${id}/events`, click: () => dispatch(setGetLastOperationAction({
            data: [],
            count: 1,
            countPage: 1
        }))},
        {label: 'Депозиты', url:  `/gamer/view/${id}/deposit`, click: () => dispatch(setGetReplenishmentUserAction({
            data: [],
            countPage: 1
        }))},
        {label: 'Выводы', url: `/gamer/view/${id}/withdrawals`, click: () =>   dispatch(setGetWithdrawalsUserAction({
            data: [],
            countPage: 1
        }))},
        {label: 'Бонусы', url: `/gamer/view/${id}/bonuses`, click: () => dispatch(setGetHistoryBonusGetByIdAction({
                data: [],
                countPage: 1
            }))},
        {label: 'Джекпоты', url: `/gamer/view/${id}/jackpot`, click: () => dispatch(setGetJackpotHistoryListAction({
            data: [],
            countPage: 1
        }))}
    ]

    const Allow = AllowMap();


    const getJackpot = (item) => {
        switch (item) {
            case 'gold': return 'Золотой';
            case 'silver': return 'Серебрянный';
            case 'bronze': return 'Бронзовый';
            case 'platinum': return 'Платиновый';
            default: return null;
        }
    }
    const list = useSelector(state => state.usersMobile.last_operation);
    
    return (
        <div style={{position: 'fixed', visibility: isShowNavigation ? 'visible' : 'hidden', opacity: isShowNavigation ? 1 : 0,  transition: 'all .3s linear', top: 0, left: 0, width: '100%', height: '100%', overflow: 'scroll', background: 'rgb(35 52 110)', zIndex: 20}}>
                
                <div style={{display: 'flex', padding: '19px 0 15px 15px', borderBottom: '1px solid #ececec'}}>
                    <div 
                        onClick={() => {
                            setIsShowNavigation(!isShowNavigation);
                        }}
                        style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingLeft: 20}}>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                        <div style={{width: 40, height: 3, background: '#fff', marginBottom: 8}}></div>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', width: 'calc(100% - 100px)'}}>
                        <span style={{color: '#fff', textTransform: 'uppercase', fontSize: 18, fontFamily: 'Montserrat, sans-serif'}}>Информация</span>
                    </div>
                   
                </div>
            {
                view?.allow?.includes(Allow.JackpotIssue.allow) &&
                <div
                    onClick={() => {
                        dispatch(setGetJackpotList({
                            group: profile.groups_cashiers
                        }))
                        setJackpot(true)
                    }}
                    style={{ position: 'relative', padding: 20, paddingBottom: 20, display: 'flex', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,.3)', background: 'gold' }}>
                    <span
                        style={{ color: 'rgb(35, 52, 110)', fontFamily: 'Montserrat, sans-serif' }}>
                        Выдать джекпот
                    </span>
                </div>
            }
                {
                    navigation.map((item) => {
                        return (
                            <>
                                <div
                                    onClick={() => {
                                        router.history.push(item.url);
                                        if (item.click) {
                                            item.click();
                                        }
                                    }} 
                                    style={{position: 'relative', padding: 20, paddingBottom: 20, display: 'flex', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,.3)'}}>
                                    <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}>
                                        {item.label}
                                    </span>
                                </div>
                            </>
                        )
                    })
                }
                <div style={{position: 'absolute', bottom: 0, width: '100%'}}>
                    {
                        view?.allow?.includes(Allow.ChangePassword.allow) && 
                        <div 
                            onClick={() => setOpenModalPassword(true)}
                            style={{position: 'relative', padding: 20, paddingBottom: 20, display: 'flex', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,.3)', background: '#494b79'}}>
                            <span 
                            
                                style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}
                                
                            >
                                Сбросить пароль
                            </span>
                        </div>
                    }
                    {
                        view?.allow?.includes(Allow.UserBlock.allow) && 
                        <div 
                            style={{position: 'relative', padding: 20, paddingBottom: 20, display: 'flex', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,.3)', background: '#fc3450'}}
                            onClick={() => setOpenModalBlock(true)}
                        >
                            
                            <span style={{color: '#fff', fontFamily: 'Montserrat, sans-serif'}}>
                                {!profile.block ? 'Заблокировать' : 'Разблокировать' }
                            </span>
                        </div>
                    }
                </div>
                <Dialog onClose={() => setOpenModalBlock(false)} open={openModalBlock}>
                    <div style={{width: 300, padding: 20}}>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <span>{!profile.block ? 'Заблокировать пользователя?' : 'Разблокировать пользователя'}</span>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', columnGap: 4, marginTop: 12}}>
                            <span 
                                style={{padding: 10, background: 'gold', color: 'rgb(35, 52, 110)', width: '50%', display: 'flex', justifyContent: 'center', borderRadius: 4}}
                                onClick={() => {
                                    dispatch(setPostBlockUser({
                                    login: profile.login,
                                    block: !profile.block,
                                    id
                                }))
                                setOpenModalBlock(false)
                            }
                                
                            }    
                            >Подтвердить</span>
                            <span 
                                style={{padding: 10, color: '#333', border: '1px solid #333', width: '50%', display: 'flex', justifyContent: 'center', borderRadius: 4}}
                                onClick={() => setOpenModalBlock(false)}    
                            >Отмена</span>
                        </div>
                    </div>
                </Dialog>
                <Dialog onClose={() => setOpenModalPassword(false)} open={openModalPassword}>
                    <div style={{width: 300, padding: 20}}>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <span>Сбросить пароль?</span>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', columnGap: 4, marginTop: 12}}>
                            <span 
                                style={{padding: 10, background: 'gold', color: 'rgb(35, 52, 110)', width: '50%', display: 'flex', justifyContent: 'center', borderRadius: 4}}
                                onClick={() => {
                                    const rand = Math.floor(Math.random() * 999999);
                                    setRandomPassword(rand);
                                    dispatch(setUpdatePassword({
                                        login: profile.login,
                                        password: String(rand)
                                    }))
                                    setOpenModalPassword(false)
                            }
                                
                            }    
                            >Подтвердить</span>
                            <span 
                                style={{padding: 10, color: '#333', border: '1px solid #333', width: '50%', display: 'flex', justifyContent: 'center', borderRadius: 4}}
                                onClick={() => setOpenModalPassword(false)}    
                            >Отмена</span>
                        </div>
                    </div>
                </Dialog>
                <Dialog onClose={() => setRandomPassword('')} open={!!randomPassword}>
                    <div style={{width: 300, padding: 20}}>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <span>Новый пароль</span>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <span>{randomPassword}</span>
                        </div>
                        
                        <div style={{display: 'flex', justifyContent: 'space-between',}}>
                            
                            <span 
                                style={{padding: 10, color: '#333', border: '1px solid #333', width: '100%', display: 'flex', justifyContent: 'center', borderRadius: 4}}
                                onClick={() => setRandomPassword('')}    
                            >OK</span>
                        </div>
                    </div>
                </Dialog>
                <Dialog onClose={() => {
                    setJackpot(false);
                    setItemJackpot();
                }} open={jackpot}>
                    <div style={{width: 300, padding: 20}}>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <select
                                onChange={(v) => {
                                    const parseObj = JSON.parse(v.target.value);
                                    
                                    const obj = {
                                        bet: list.data.length ? list.data[0].amount_bet : '',
                                        game_uuid: list.data.length ? list.data[0].game_uuid : '',
                                        group: profile.groups_cashiers,
                                        id: +parseObj.id,
                                        jackpot: parseObj.jackpot,
                                        type: "give out",
                                        user: profile.login,
                                        amount: +parseObj.amount
                                    }
                                    setItemJackpot(obj);
                                }}
                                style={{padding: 10, border: '1px solid #eee', borderRadius: 4, width: '100%'}}
                            >
                                <option selected style={{display:'none'}}>Выбрать джекпоты</option>
                                {
                                    jackpot_group && jackpot_group.map((item) => <option value={`{"id": "${item.id}", "jackpot": "${item.jackpot}", "amount": "${item.primary_amount}"}`}>{getJackpot(item.jackpot)}({item.primary_amount ? (+item.primary_amount).toFixed(2) : item.primary_amount})</option>)
                                }
                            </select>
                        </div>
                        {
                            itemJackpot && 
                            <div style={{display: 'flex', justifyContent: 'center', margin: '12px 0'}}>
                                <span style={{fontSize: 18}}>Сумма: {new Intl.NumberFormat('ru-RU').format(itemJackpot.amount ? itemJackpot.amount.toFixed(2) : itemJackpot.amount)} </span>
                            </div>
                        }
                       
                        <div style={{marginTop: 12}}>
                            <span style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700
                        }}
                            onClick={() => {
                                dispatch(setPostJackpotIssue(itemJackpot))
                                setItemJackpot();
                                setJackpot(false)
                            }} 
                        >Выдать</span>
                        </div>
                    </div>
                </Dialog>
            </div> 
    )
}

export default Navigation;